import module from '../module';

class PayPalPaymentFormDirectiveController {
    static $inject = [ '$scope', 'Message' ];

    constructor(scope, messageService) {

        this._scope = scope;
        this._messageService = messageService;
    }
}

module.directive('payPalPaymentForm', function () {
    return {
        scope: {},
        templateUrl: 'modules/shared/views/payPalPaymentForm.html',
        controller: PayPalPaymentFormDirectiveController
    };
});


// WEBPACK FOOTER //
// ./src/modules/shared/directives/PayPalPaymentForm.js